module.exports = __webpack_public_path__ + "img/chevron-right.e0ed59f0.svg";